import React, { useState } from "react";
import { jsPDF } from "jspdf";
import "./BuildingTaxRates.css";

const BuildingTaxRates = () => {
  const [form, setForm] = useState({
    rcc: "100.00",
    itarPakke: "50.00",
    ardhaPakke: "25.00",
    kacche: "10.00",

    samanyaPaani: "121.00",
    visheshPaani: "25.00",
    paaniPatti: "0.00",

    khuliJaga: "25.00",
    khuliJagaRakkam: "",
    towerKar: "",

    diva0to300: "10.00",
    arogya0to300: "10.00",
    diva300to700: "10.00",
    arogya300to700: "10.00",
    divaAbove700: "10.00",
    arogyaAbove700: "10.00",

    itarKar: "2.00",
    tharavKramank: "4",
    tharavDate: "2026-01-07",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    console.log("Saving building tax rates:", form);
    alert("इमारतीवरील दरे यशस्वीरित्या सेव्ह झाले! ✅");
  };

  const handleReset = () => {
    setForm({
      rcc: "100.00",
      itarPakke: "50.00",
      ardhaPakke: "25.00",
      kacche: "10.00",
      samanyaPaani: "121.00",
      visheshPaani: "25.00",
      paaniPatti: "0.00",
      khuliJaga: "25.00",
      khuliJagaRakkam: "",
      towerKar: "",
      diva0to300: "10.00",
      arogya0to300: "10.00",
      diva300to700: "10.00",
      arogya300to700: "10.00",
      divaAbove700: "10.00",
      arogyaAbove700: "10.00",
      itarKar: "2.00",
      tharavKramank: "4",
      tharavDate: "2026-01-07",
    });
  };

  const generatePDF = async () => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      
      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("नवीन इमारतीवरील दरांची माहिती", pageWidth / 2, 10, { align: "center" });
      
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);
      
      const tableData = [
        ["इमारतीवरील कर", ""],
        ["आर. सी. सी.", form.rcc],
        ["इतर पक्के", form.itarPakke],
        ["अर्धा पक्के", form.ardhaPakke],
        ["कच्चे", form.kacche],
        ["", ""],
        ["पाणी कर", ""],
        ["सामान्य पाणी", form.samanyaPaani],
        ["विशेष पाणी", form.visheshPaani],
        ["पाणी पट्टी", form.paaniPatti],
      ];
      
      pdf.autoTable({
        body: tableData,
        startY: 32,
        theme: "grid",
        columnStyles: {
          0: { cellWidth: 100 },
          1: { cellWidth: 50 }
        },
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold"
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 10
        }
      });
      
      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(`पृष्ठ ${i} / ${pageCount}`, pageWidth / 2, pdf.internal.pageSize.getHeight() - 10, { align: "center" });
      }
      
      pdf.save("इमारत-दर-माहिती.pdf");
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  return (
    <div className="building-tax-container">
      <div className="tax-header">नवीन इमारतीवरील दरांची माहिती</div>

      {/* इमारतीवरील कर */}
      <div className="tax-section">
        <b className="section-title">इमारतीवरील कर</b>
        <div className="tax-row">
          <div className="tax-field">
            <label>
              आर. सी. सी. <span className="req">*</span>
            </label>
            <input
              type="number"
              step="0.01"
              name="rcc"
              value={form.rcc}
              onChange={handleChange}
            />
          </div>
          <div className="tax-field">
            <label>
              इतर पक्के घर <span className="req">*</span>
            </label>
            <input
              type="number"
              step="0.01"
              name="itarPakke"
              value={form.itarPakke}
              onChange={handleChange}
            />
          </div>
          <div className="tax-field">
            <label>
              अर्ध पक्के घर <span className="req">*</span>
            </label>
            <input
              type="number"
              step="0.01"
              name="ardhaPakke"
              value={form.ardhaPakke}
              onChange={handleChange}
            />
          </div>
          <div className="tax-field">
            <label>
              कच्चे घर <span className="req">*</span>
            </label>
            <input
              type="number"
              step="0.01"
              name="kacche"
              value={form.kacche}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* पाणीपट्टी कर */}
      <div className="tax-section">
        <b className="section-title">पाणीपट्टी कर</b>
        <div className="tax-row three-col">
          <div className="tax-field">
            <label>सामान्य पाणीपट्टी कर</label>
            <input
              type="number"
              step="0.01"
              name="samanyaPaani"
              value={form.samanyaPaani}
              onChange={handleChange}
            />
          </div>
          <div className="tax-field">
            <label>विशेष पाणीपट्टी कर</label>
            <input
              type="number"
              step="0.01"
              name="visheshPaani"
              value={form.visheshPaani}
              onChange={handleChange}
            />
          </div>
          <div className="tax-field">
            <label>पाणीपट्टी</label>
            <input
              type="number"
              step="0.01"
              name="paaniPatti"
              value={form.paaniPatti}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* खुली जागा */}
      <div className="tax-section">
        <b className="section-title">खुली जागा दरांची माहिती</b>
        <div className="tax-row three-col">
          <div className="tax-field">
            <label>खुली जागा</label>
            <input
              type="number"
              step="0.01"
              name="khuliJaga"
              value={form.khuliJaga}
              onChange={handleChange}
            />
          </div>
          <div className="tax-field">
            <label>खुली जागेची रक्कम</label>
            <input
              type="number"
              step="0.01"
              name="khuliJagaRakkam"
              value={form.khuliJagaRakkam}
              onChange={handleChange}
            />
          </div>
          <div className="tax-field">
            <label>टॉवर कर</label>
            <input
              type="number"
              step="0.01"
              name="towerKar"
              value={form.towerKar}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* दिवाबत्ती / आरोग्य */}
      <div className="tax-section">
        <b className="section-title">दिवाबत्ती कर / आरोग्य कर</b>

        <div className="tax-row-label">
          <div className="label-text">0 ते 300 चौ.फुट सर्व इमारती</div>
          <div className="input-group">
            <div className="tax-field">
              <label>दिवाबत्ती</label>
              <input
                type="number"
                step="0.01"
                name="diva0to300"
                value={form.diva0to300}
                onChange={handleChange}
              />
            </div>
            <div className="tax-field">
              <label>आरोग्य</label>
              <input
                type="number"
                step="0.01"
                name="arogya0to300"
                value={form.arogya0to300}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="tax-row-label">
          <div className="label-text">300 ते 700 चौ.फुट सर्व इमारती</div>
          <div className="input-group">
            <div className="tax-field">
              <label>दिवाबत्ती</label>
              <input
                type="number"
                step="0.01"
                name="diva300to700"
                value={form.diva300to700}
                onChange={handleChange}
              />
            </div>
            <div className="tax-field">
              <label>आरोग्य</label>
              <input
                type="number"
                step="0.01"
                name="arogya300to700"
                value={form.arogya300to700}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="tax-row-label">
          <div className="label-text">700 चौ.फुट पेक्षा जास्त क्षेत्रफळ</div>
          <div className="input-group">
            <div className="tax-field">
              <label>दिवाबत्ती</label>
              <input
                type="number"
                step="0.01"
                name="divaAbove700"
                value={form.divaAbove700}
                onChange={handleChange}
              />
            </div>
            <div className="tax-field">
              <label>आरोग्य</label>
              <input
                type="number"
                step="0.01"
                name="arogyaAbove700"
                value={form.arogyaAbove700}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="tax-row">
          <div className="tax-field">
            <label>इतर कर</label>
            <input
              type="number"
              step="0.01"
              name="itarKar"
              value={form.itarKar}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* ग्रामपंचायत ठराव */}
      <div className="tax-section">
        <b className="section-title">ग्रामपंचायत ठराव</b>
        <div className="tax-row">
          <div className="tax-field">
            <label>
              ठराव क्रमांक <span className="req">*</span>
            </label>
            <input
              type="text"
              name="tharavKramank"
              value={form.tharavKramank}
              onChange={handleChange}
            />
          </div>
          <div className="tax-field">
            <label>
              ठराव दिनांक <span className="req">*</span>
            </label>
            <input
              type="date"
              name="tharavDate"
              value={form.tharavDate}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="center-btn">
        <button className="btn-blue" onClick={handleSave}>
          बदल करा
        </button>
        <button className="btn-reset" onClick={handleReset}>
          रीसेट करा
        </button>
        <button className="btn-pdf-all" onClick={() => generatePDF()}>
          📄 PDF डाउनलोड करा
        </button>
      </div>
    </div>
  );
};

export default BuildingTaxRates;
